// Amenity catalog for the venue profile (academies.amenities). Stored as
// these keys; anything else in the list is a venue's own custom amenity and
// is shown as typed. Keep in step with KBA-Mobile src/content/amenities.ts.
import {
  Car, Bath, Shirt, GlassWater, ShowerHead, Cross, Coffee, Armchair, Wifi,
  Lock, Package, GraduationCap, Snowflake, Zap, Lightbulb, Layers,
} from 'lucide-react';

export const AMENITIES = [
  { key: 'parking', label: 'Parking', icon: Car },
  { key: 'washroom', label: 'Washrooms', icon: Bath },
  { key: 'changing_room', label: 'Changing room', icon: Shirt },
  { key: 'drinking_water', label: 'Drinking water', icon: GlassWater },
  { key: 'showers', label: 'Showers', icon: ShowerHead },
  { key: 'first_aid', label: 'First aid', icon: Cross },
  { key: 'cafeteria', label: 'Cafeteria', icon: Coffee },
  { key: 'seating', label: 'Seating area', icon: Armchair },
  { key: 'wifi', label: 'Wi-Fi', icon: Wifi },
  { key: 'lockers', label: 'Lockers', icon: Lock },
  { key: 'equipment_rental', label: 'Equipment rental', icon: Package },
  { key: 'coaching', label: 'Coaching', icon: GraduationCap },
  { key: 'air_conditioning', label: 'Air conditioning', icon: Snowflake },
  { key: 'power_backup', label: 'Power backup', icon: Zap },
  { key: 'floodlights', label: 'Floodlights', icon: Lightbulb },
  { key: 'wooden_flooring', label: 'Wooden flooring', icon: Layers },
];

const BY_KEY = Object.fromEntries(AMENITIES.map((a) => [a.key, a]));

export const amenityInfo = (key) => BY_KEY[key] || { key, label: key, icon: null };
